import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { Button, Classes, Dialog, Intent, MenuItem } from '@blueprintjs/core';
import { observer } from 'mobx-react';
import { IconNames } from '@blueprintjs/icons';
import { SystemStatus } from '../../store/models/SystemStatus';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import { Form } from 'react-final-form';
import { TextInputFormField } from '../common/form';
import { toJS } from 'mobx';
import SelectInputFormField from '../common/form/SelectInputFormField';
import { IItemRendererProps } from '@blueprintjs/select';

interface SystemStatusFormProps extends WithTranslateProps {
  systemStatus?: Instance<typeof SystemStatus>;
  onSave: (data) => void;
  onStop: () => void;
  status: string[];
}

@observer
class SystemStatusForm extends React.Component<SystemStatusFormProps> {
  renderStatusMenuItem(item: any, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return <MenuItem key={`status-${index}`} active={modifiers.active} onClick={handleClick} text={item.label} />;
    } else {
      return null;
    }
  }

  filterStatus = (query, status) => {
    return status.label.indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { onSave, onStop, systemStatus, status } = this.props;
    const finalStatusList = status.map((elem) => ({ id: elem, label: elem }));

    return (
      <Dialog
        isOpen={systemStatus !== undefined}
        onClose={onStop}
        icon={IconNames.EDIT}
        title={
          <TranslatedMessage
            id={
              this.state && systemStatus && systemStatus.systemStatusId === -1
                ? TLCode.SECRETARIAT_DASHBOARD_CreateStatus
                : TLCode.SECRETARIAT_DASHBOARD_EditStatus
            }
          />
        }
      >
        {systemStatus && (
          <div className={Classes.DIALOG_BODY}>
            <Form
              initialValues={systemStatus}
              onSubmit={onSave}
              render={({ handleSubmit, hasValidationErrors, dirty }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    {/*<NumberInputFormField*/}
                    {/*  name="year"*/}
                    {/*  label={TLCode.SECRETARIAT_DASHBOARD_Year}*/}
                    {/*  inline={true}*/}
                    {/*  required={true}*/}
                    {/*  fill={true}*/}
                    {/*  autoFocus={true}*/}
                    {/*  disabled={systemStatus.systemStatusId > 0}*/}
                    {/*/>*/}
                    <TextInputFormField
                      name="year"
                      label={TLCode.SECRETARIAT_DASHBOARD_Year}
                      inline={true}
                      required={true}
                      fill={true}
                      autoFocus={true}
                      disabled={systemStatus.systemStatusId > 0}
                    />
                    <SelectInputFormField
                      label={TLCode.SECRETARIAT_DASHBOARD_Status}
                      name="status"
                      inline={true}
                      items={toJS(finalStatusList)}
                      itemValueGetter={(item: any) => item.id}
                      valueItemGetter={(value) => ({ id: value, label: value })}
                      inputValueRenderer={(item) => (item != null ? item.id : '')}
                      itemRenderer={this.renderStatusMenuItem}
                      itemPredicate={this.filterStatus}
                      identifier={'id'}
                      elementLabel={'label'}
                      labelSelectAnElement={this.props.translate(TLCode.CHOOSE_A_STATUS)}
                      helperText={this.props.translate(TLCode.CHOOSE_A_STATUS)}
                      placeholderSelection={TLCode.CHOOSE_A_STATUS}
                    />
                    <div className={Classes.DIALOG_FOOTER}>
                      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button text={<TranslatedMessage id={TLCode.GENERAL_Cancel} />} onClick={onStop} />
                        <Button
                          type="submit"
                          intent={Intent.PRIMARY}
                          disabled={hasValidationErrors || (!dirty && systemStatus.systemStatusId > 0)}
                          text={<TranslatedMessage id={TLCode.GENERAL_Save} />}
                        />
                      </div>
                    </div>
                  </form>
                );
              }}
            />
          </div>
        )}
      </Dialog>
    );
  }
}

export default withTranslate(SystemStatusForm);
